import { ReactElement } from "react";
import {
  Popover,
  PopoverContent,
  PopoverProps,
  PopoverTrigger,
  Portal,
} from "@chakra-ui/react";
import SkuPreviewPopoverContent from "./Content";

export type SkuPreviewPopoverProps = Pick<PopoverProps, "placement"> & {
  children: ReactElement;
  isAdmin?: boolean;
  isInPortal?: boolean;
  skuId: UUID | null | undefined;
};

export default function SkuPreviewPopover({
  children,
  isAdmin,
  isInPortal,
  skuId,
  ...rest
}: SkuPreviewPopoverProps) {
  if (!skuId) return children;

  const content = (
    <PopoverContent onClick={(evt) => evt.stopPropagation()} width="24.5rem">
      <SkuPreviewPopoverContent {...{ isAdmin, skuId }} />
    </PopoverContent>
  );

  return (
    <Popover isLazy trigger="hover" openDelay={650} {...rest}>
      <PopoverTrigger>{children}</PopoverTrigger>
      {isInPortal ? <Portal>{content}</Portal> : content}
    </Popover>
  );
}
